import { TranslationKey } from './../../../../types/translation/TranslationKey';
import React, { JSX } from 'react';
import { t } from '../../../../types/translation/Translator';
import { BaseFilter, BaseFilterProps } from '../common/BaseFilter';
import { CalendarIcon } from '../../../icons/Calendar/CalendarIcon';
import { DateTimeFilterContent } from './Content/DateTimeFilterContent';
import { FilterProps } from '../common/filter.util';
import dayjs from 'dayjs';

export class DateTimeFilter extends BaseFilter<Date> {
  toLabel(props: BaseFilterProps): string {
    return t(TranslationKey.dateAndTime).singular.label;
  }

  toString(props: BaseFilterProps): string {
    return this.toLabel(props);
  }

  toCount(): number {
    return 0;
  }

  toIcon(): JSX.Element {
    return <CalendarIcon className={this.className} />;
  }

  toDropdownContent(props: BaseFilterProps, open: boolean): JSX.Element {
    return <></>;
  }

  search(item: Date, textFilter: string) {
    return true;
  }

  handleChange(start: Date, end: Date, props: BaseFilterProps) {
    if (!props.filterProps.timeFrame) props.filterProps.timeFrame = { start: start, end: end };
    props.filterProps.timeFrame = { start: dayjs(start).startOf('day').toDate(), end: end };
  }

  toInnerContent(props: BaseFilterProps): string | JSX.Element {
    return <></>;
  }

  toComponent(props: BaseFilterProps): React.JSX.Element {
    return <DateTimeFilterContent props={props} />;
  }

  filteredItems(items: Date[], query: string, filterProps: FilterProps): Date[] {
    return items.filter(item => {
      return [DateTimeFilter.filter(filterProps, item), this.search(item, query)].every(
        value => value === null || value,
      );
    });
  }

  static filter(filterProps: FilterProps, item?: Date) {
    if (!item) return true;
    if (!filterProps.timeFrame) return true;
    return item >= new Date(filterProps.timeFrame.start) && item <= new Date(filterProps.timeFrame.end);
  }
}
